// extracted by mini-css-extract-plugin
export var filterIncDec = "_a4-0";
export var leftBorder = "_a4-1";
export var rightBorder = "_a4-2";
export var stringInput = "_a4-3";